export const mutations = {
  UPDATE_CLIENT_PROFILE_DETAILS_MUTATION(state: any, payload: any) {
    state.clientDetails = payload
  }
}
